<template>
  <div class>
    <div class="table-page-search-wrapper">
      <a-row :gutter="12" style="margin:0px 0px 16px 0px;">
        <a-button @click="addStudent" type="primary" style="margin-left:10px;vertical-align: middle;">添加学员</a-button>
        <!-- <a-button @click="moveOtherClass" type="primary" style="margin-left:10px;vertical-align: middle;">调至其他班</a-button> -->
        <a-button @click="batchDel" type="primary" style="margin-left:10px;vertical-align: middle;">移除本班</a-button>

      </a-row>
    </div>
    <div>
      <a-table
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        ref="table"
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        @change="handleTableChange"
      >
        <span slot="sex" slot-scope="text, record,index">
          {{!text?"-":""}}
          {{text=="1"?"男":""}}
          {{text=="2"?"女":""}}
        </span>
        <span slot="action" slot-scope="text, record,index">
          <span >
              <!-- <a @click="moveOtherClass(record)"  >调至其他班</a>
              <a-divider type="vertical" /> -->
              <!-- <a-popconfirm title="确定移出吗?" @confirm="() => removeClass(record)">
                <a>移出本班</a>
              </a-popconfirm> -->
              <a-popconfirm title="确定移出吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
          </span>
        </span>

        <!-- <span slot="courseName" slot-scope="text, record">
          <span style='color:#333;font-size:14px;'>{record.courseName}</span>
          <span style='color:#999;font-size:12px;'>{record.time}</span>
        </span>-->
      </a-table>
      <SelectStudentModal ref="selectStudentModal"  @ok = "loadData" />
    </div>
  </div>
</template>

<script>

import SelectStudentModal from './SelectStudentModal'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
export default {
  name: 'CourseStudentsManage',
  components: {
    SelectStudentModal
  },
  mixins: [JeecgListMixin],
  data() {
    return {
      description: '学员管理',
      firstIsNotLoad:true,
      loading:false,
      queryParam:{
        gradeId:"",
        name:""
      },
      url: {
        list: "/grade/elinkxGradeUserRel/list",
        delete: "/grade/elinkxGradeUserRel/delete",
        deleteBatch: "/grade/elinkxGradeUserRel/deleteBatch",
        exportXlsUrl: "course/elinkxCourse/exportXls",
        importExcelUrl: "course/elinkxCourse/importExcel",
      },
      columns: [
        {
          title: '姓名',
          align: 'center',
          dataIndex: 'realname',
          width: 200
        },
        {
          title: '性别',
          align: 'center',
          dataIndex: 'sex',
          width: 120,
          scopedSlots: { customRender: 'sex' },
        },
        {
          title: '手机号',
          align: 'center',
          dataIndex: 'phone',
          width: 100
        },
        {
          title: '课程名',
          align: 'center',
          dataIndex: 'courseNames',
          width: 100
        },
        {
          title: '操作',
          dataIndex: 'action',
          align:"center",
          scopedSlots: { customRender: 'action' },
          width:300
        }
      ],
      dataSource: [
        
      ],
      selectedRowKeys: []
    }
  },
  created () {
    this.queryParam.gradeId = this.$route.query.id;
    this.loadData();
  },
  methods: {
    removeClass(){

    },
    moveOtherClass(){

    },
    addStudent(){
      this.$refs.selectStudentModal.add(this.queryParam.gradeId);
    },
    onSelectChange(selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
    },
    onChange:(checked)=>{
      console.log(`a-switch to ${checked}`);
    },
    handleTableChange(){

    }
  }
}
</script>

<style scoped>
</style>